import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: 'lg:pt-6',
    base: 'container mx-4 mt-3.5 mb-30 flex flex-col gap-4 lg:mt-12 lg:flex-row lg:gap-22 lg:px-9',
    sidebar: 'relative hidden shrink-0 lg:block lg:w-1/4',
    banners: 'hidden lg:block',
    contentContainer: 'min-w-0 flex-1',
    title: 'heading-2xl lg:heading-3xl mb-6 font-medium lg:font-medium',
    back: 'lg:hidden',
    backButton: 'px-0',
    backText: 'ml-2 max-lg:text-xs max-lg:tracking-[0.8px] max-lg:uppercase',
    backIcon: 'scale-x-[-1]'
  },
  variants: {
    openMenu: {
      true: {
        back: 'hidden',
        banners: 'block',
        contentContainer: 'hidden lg:block',
        sidebar: 'block',
        banner: 'block'
      }
    }
  }
});
